<template>
    <v-app id="inspire" v-cloak>
        <v-navigation-drawer v-model="drawer" app>
            <v-list shaped>
                <v-list-item link to="/admin/board" color="#1976d2">
                    <v-list-item-action>
                        <v-icon>mdi-monitor-dashboard</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold">Board</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group prepend-icon="mdi-feather" light>
                    <template v-slot:activator>
                        <v-list-item-title class="subtitle-1 font-weight-bold">Article</v-list-item-title>
                    </template>

                    <v-list-item link to="/admin/article-list">
                        <v-list-item-action>
                            <v-icon>mdi-view-list</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-2 font-weight-bold">List</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link to="/admin/article">
                        <v-list-item-action>
                            <v-icon>mdi-plus</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-2 font-weight-bold">Add</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link to="/admin/article-trash">
                        <v-list-item-action>
                            <v-icon>mdi-trash-can-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-2 font-weight-bold">Trash</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-item link to="/admin/comment-list" color="#1976d2">
                    <v-list-item-action>
                        <v-icon>mdi-comment-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-2 font-weight-bold">Comment</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link to="/admin/jiwai-list" color="#1976d2">
                    <v-list-item-action>
                        <v-icon>mdi-chat-processing</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold">Jiwai</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group prepend-icon="mdi-settings" light :value="false">
                    <template v-slot:activator>
                        <v-list-item-title class="subtitle-1 font-weight-bold">Setting</v-list-item-title>
                    </template>

                    <v-list-item link>
                        <v-list-item-action>
                            <v-icon>mdi-language-html5</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-2 font-weight-bold">Static</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-action>
                            <v-icon>mdi-account-box-multiple</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-2 font-weight-bold">Account</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-item>
                    <v-list-item-action>
                        <v-icon>mdi-heart-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold">Thanks</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-action>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold">Logout</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app color="indigo" dark>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title>GoBlog Backend</v-toolbar-title>
        </v-app-bar>

        <v-content>
            <router-view :key="$route.fullPath"></router-view>
        </v-content>
        <v-footer color="indigo" app>
            <span class="white--text">&copy; 2020</span>
        </v-footer>
    </v-app>
</template>

<script>
export default {
    name: "admin",
    data: () => ({
        drawer: true
    })
};
</script>

<style scoped></style>
